import { v4 as uuid } from 'uuid';

export function newPushDelivery() {
  return {
    mode: 'off',
    title: '',
    body: '',
    image: '',
    time: '',
    requestId: uuid(),
  };
}

export function localDeliveryTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
}

export function pushDeliveryError(delivery, lifecycle, now = Date.now()) {
  if (!delivery || delivery.mode === 'off') return null;
  if (!['now', 'later'].includes(delivery.mode))
    return 'Choose when to send the notification.';
  if (!delivery.title?.trim() || !delivery.body?.trim())
    return 'Add a notification title and message.';
  if (delivery.title.trim().length > 100 || delivery.body.trim().length > 300)
    return 'Shorten the notification title or message.';
  if (delivery.image) {
    try {
      const url = new URL(delivery.image);
      if (url.protocol !== 'https:' || url.username || url.password)
        throw Error();
    } catch {
      return 'Use an HTTPS link for the notification image.';
    }
  }
  const at = delivery.mode === 'later' ? Date.parse(delivery.time) : now;
  if (
    delivery.mode === 'later' &&
    (!Number.isFinite(at) || at < now + 60000 || at > now + 366 * 86400000)
  )
    return 'Choose a send time at least one minute ahead and within the next year.';
  if (lifecycle?.startAt && at < Date.parse(lifecycle.startAt))
    return 'The LifeObject must be available when its notification is sent.';
  if (lifecycle?.endAt && at >= Date.parse(lifecycle.endAt))
    return 'Send the notification before this LifeObject expires.';
  return null;
}

// Invoke only after the LifeObject and its resource links are saved. Persisting
// the request ID makes publish retries and reopening the editor idempotent.
export async function deliverPublishedObject(saved, delivery, run) {
  if (
    saved.lifecycle?.status !== 'active' ||
    !delivery ||
    delivery.mode === 'off'
  )
    return null;
  const result = await run('sendFollowerPush', {
    requestId: delivery.requestId,
    lifeObjectId: saved.id,
    title: delivery.title,
    body: delivery.body,
    image: delivery.image,
    confirm: true,
    ...(delivery.mode === 'later'
      ? { scheduledAt: new Date(delivery.time).toISOString() }
      : {}),
  });
  if (
    ['not_sent', 'cancelled', 'delivery_uncertain', 'sending'].includes(
      result.status
    )
  ) {
    throw new Error(
      ['delivery_uncertain', 'sending'].includes(result.status)
        ? 'Your LifeObject is saved. Notification delivery is not confirmed; check its status before starting another send.'
        : 'Your LifeObject is saved, but this notification was not sent. Review its status before starting another send.'
    );
  }
  return result;
}
